<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [cancelLabel]="closeLabel()"
  [showConfirm]="false"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
>
  <eventq-actionable-list
    appearance="tiles"
    [showSearch]="false"
    [items]="listItems()"
    [activateLabel]="activateLabel()"
    listAriaLabel="Talkdown messages"
    (activate)="onActivate($event)"
  />
</eventq-dialog-popover>
